import WebApp from '@twa-dev/sdk';
import { isIOS, isMacOs, isSafari } from 'react-device-detect';

import { UIKit } from '../store/app-store/types';
import { isTMA } from './is-tma';

export const getUIKit = (webApp?: typeof WebApp): UIKit => {
  if (!isTMA()) {
    return isIOS || isSafari || isMacOs ? UIKit.APPLE : UIKit.MATERIAL;
  }

  const platform = (webApp || WebApp)?.platform;

  if (['macos', 'ios'].includes(platform)) {
    return UIKit.APPLE;
  }

  return UIKit.MATERIAL;
};
